export const hireReactNativePageContent = {
    // Helmet Content
    helmet: {
        title: "Hire Expert React Native Developers",
        description: "Looking to hire skilled React Native developers? Bitsclan offers pre-vetted, experienced professionals to build high-quality, feature-rich apps. Schedule a call today to get started!",
    },

    // HirePageBanner Content
    mainBanner: {
        backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
        shortHeading: "BUSINESS-DRIVEN REACT NATIVE EXPERTS ACCELERATING MOBILE INNOVATION",
        mainHeading: "Trusted by 40+ enterprises, our <span>React Native engineers</span> build fast, scalable apps.",
        content: " We specialize in creating seamless mobile experiences using a single, unified codebase reducing time to market by up to 40% and lowering maintenance costs by 30%. Partner with us to deliver faster, smarter, and future-ready mobile solutions that elevate your digital presence and boost measurable ROI.",
        btnText: "Consult our React Native developers",
        bannerList: [
            { list: "Freelance contractors" },
            { list: "Full-time roles" },
            { list: "Global teams" },
        ],
    },

    // Trusted By Section
    trustedBy: {
        heading: "Trusted & Partnered by Businesses Worldwide to Build High-Performance React Native Solutions"
    },

    // HirePageSteps Content
    hireSteps: {
        btnText: "Let's Find Your Perfect Developer",
        heading: "How to Engage React Native Engineers in 3 Simple Steps",
        subHeading: "Hiring expert React Native developers is simple with our streamlined process. We focus on making sure you get the right developer for your project—fast, reliable, & cost-effective.",
        steps: [
            {
                title: "Share Your Requirements",
                description: "Talk to our React Native consultants about your goals, app vision, and technical needs. We understand your workflow before matching you with the right experts.",
                icon: "/images/hire-page-setps-icons/icon-1.svg",
            },
            {
                title: "Meet Your Development Team",
                description: "Within 48 hours, we'll connect you with hand-selected React Native engineers aligned with your goals and tech stack. They'll start contributing from day one.",
                icon: "/images/hire-page-setps-icons/icon-2.svg",
            },
            {
                title: "Start Building with Confidence",
                description: "We offer a risk-free trial period to ensure the perfect fit. If you're not satisfied, we'll provide a replacement at no additional cost.",
                icon: "/images/hire-page-setps-icons/icon-3.svg",
            },
        ],
    },

    // HirePageExperties Content
    reactNativeExpertise: {
        btnText: "Hire React Native Developers For Any Service",
        shortHeading: "Our React Native Development Expertise",
        heading: "Building Seamless, Scalable Cross-Platform Applications that Drive Business Growth",
        description: "Our React Native developers combine JavaScript, TypeScript, and native APIs to deliver flexible, efficient, and maintainable mobile applications. From MVPs to enterprise-level products, we ensure your apps perform flawlessly across both Android and iOS.",
        servicesData: [
            {
                title: "Custom React Native App Development",
                description: "End-to-end app development with reusable components and clean architecture for performance and scalability.",
                icon: "/images/hire-page-icons/flutter-icon-1.svg",
            },
            {
                title: "Migration to React Native",
                description: "Move your existing iOS or Android apps to React Native with zero downtime and full data retention.",
                icon: "/images/hire-page-icons/flutter-icon-2.svg",
            },
            {
                title: "API & Third-Party Integration",
                description: "Seamless integration with REST, GraphQL, Firebase, AWS, or custom APIs for real-time data connectivity.",
                icon: "/images/hire-page-icons/flutter-icon-3.svg",
            },
            {
                title: "UI/UX Design & Optimization",
                description: "Pixel-perfect UI aligned with your brand, optimized for performance and accessibility across platforms.",
                icon: "/images/hire-page-icons/flutter-icon-4.svg",
            },
            {
                title: "React Native for Web & Desktop",
                description: "Extend your mobile app to web and desktop using React Native Web and Electron for unified experience.",
                icon: "/images/hire-page-icons/flutter-icon-5.svg",
            },
            {
                title: "CI/CD Automation & DevOps",
                description: "Streamlined build, test, and deploy pipelines using tools like Fastlane, App Center, and GitHub Actions.",
                icon: "/images/hire-page-icons/flutter-icon-6.svg",
            },
            {
                title: "App Maintenance & Optimization",
                description: "Continuous support, bug fixes, and performance upgrades to keep your app future-ready.",
                icon: "/images/hire-page-icons/flutter-icon-7.svg",
            },
        ],
    },

    // Client Testimonials

    testimonials: [
        {
            name: "David Shaw",
            enterprise: "Fintech Solutions",
            country: "London, UK",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "CTO at FinLink Global",
            profileImage: "/images/testimonials/david-shaw.avif",
            logoImage: "/images/logo-2.png",
            text: "The React Native engineers helped us build a cross platform fintech app with native performance. We launched 35% faster and cut maintenance costs significantly.",
            serviceTags: ["Fintech Solutions"]
        },
        {
            name: "Sophia Martinez",
            enterprise: "Healthcare AI",
            country: "New York, USA",
            countryFlagImage: "/images/testimonials/flags/usa-flag.png",
            designation: "Product Lead at MedTrack Health",
            profileImage: "/images/testimonials/sophie-martinez.avif",
            logoImage: "/images/logo-2.png",
            text: "Their React Native team delivered a secure, scalable patient app that works flawlessly on iOS and Android. Collaboration and delivery were top notch.",
            serviceTags: ["Healthcare Solutions"]
        },
    ],

    // CTA Section
    ctaSection: {
        heading: "Empower Your Mobile Vision with React Native Engineering Excellence",
        subHeading: "Accelerate delivery, elevate performance, and scale confidently with experts who specialize in building high-quality, cross-platform apps for modern businesses.",
        btnText: "Let's Build with the Experts"
    },

    // DevelopmentPerformance Content (Why Choose Us)
    whyChooseUs: {
        shortHeading: "React Native App Developers You Can Count on",
        greenHeading: "Why Work with Our",
        mainHeading: " React Native Engineers?",
        description: "We bring together world-class React Native engineers who specialize in building scalable, high-performance, and feature rich cross platform applications that empower your business. Our developers combine deep technical expertise, UI/UX precision, and enterprise delivery discipline to help you launch faster, scale smarter, and achieve measurable growth across mobile platforms.",
        statsData: [
            {
                number: "7+",
                title: "Years of Experience in React Native App Development"
            },
            {
                number: "20+",
                title: "Certified Cross-Platform Engineers"
            },
            {
                number: "100+",
                title: "High-Performance Mobile Apps Delivered"
            },
            {
                number: "40%",
                title: "Faster Time to Market Through Agile CI/CD Workflows"
            },
        ]
    },

    // HireCombinationSection Content
    techCombinations: {
        shortHeading: "Powerful Technology Combinations Our React Native Engineers Use",
        heading: "Building Smart, Scalable, and Cross-Platform Apps with AI, Cloud, and Automation",
        description: "We merge React Native's robust framework with AI innovation, modern backend systems, and cloud infrastructure to deliver mobile solutions that are intelligent, high-performing, and enterprise-ready. Each combination enhances speed, personalization, and scalability driving tangible business impact.",
        combinations: [
            {
                title: "React Native + TypeScript",
                description: "Strongly typed, maintainable architecture for enterprise apps.",
                icons: [
                    { icon: "react.svg", altText: "React Native framework" },
                    { icon: "typescript.svg", altText: "TypeScript programming language" },
                ],
            },
            {
                title: "React Native + Redux Toolkit",
                description: "Predictable state management for complex, data-heavy mobile apps.",
                icons: [
                    { icon: "react.svg", altText: "React Native framework" },
                    { icon: "redux.svg", altText: "Redux state management" },
                ],
            },
            {
                title: "React Native + Expo + React Navigation",
                description: "Fast development, optimized UI, and seamless navigation flows.",
                icons: [
                    { icon: "react.svg", altText: "Expo framework" },
                    { icon: "react-navigation.png", altText: "React Navigation library" },
                ],
            },
            {
                title: "React Native + Reanimated + Gesture Handler",
                description: "Smooth animations and gesture-driven interactions.",
                icons: [
                    { icon: "reanimated.svg", altText: "Reanimated animations library" },
                    { icon: "gesture-handler.svg", altText: "Gesture Handler library" },
                ],
            },
            {
                title: "React Native + Tailwind CSS / Styled Components",
                description: "Consistent, modern design systems across platforms.",
                icons: [
                    { icon: "react.svg", altText: "Styled Components styling library" },
                    { icon: "tailwind.png", altText: "Tailwind CSS utility framework" },
                ],
            },
            {
                title: "React Native + Node.js (Express / NestJS)",
                description: "Fast, scalable backend APIs for mobile data processing.",
                icons: [
                    { icon: "nodejs.svg", altText: "Node.js runtime" },
                    { icon: "express.svg", altText: "Express backend framework" },
                ],
            },
            {
                title: "React Native + GraphQL (Apollo)",
                description: "Efficient data querying and real-time synchronization.",
                icons: [
                    { icon: "react.svg", altText: "Apollo GraphQL client" },
                    { icon: "graphql.svg", altText: "GraphQL query language" },
                ],
            },
            {
                title: "React Native + Firebase / Firestore",
                description: "Real-time database, authentication, and analytics integration.",
                icons: [
                    { icon: "react.svg", altText: "Firestore real-time database" },
                    { icon: "firebase.png", altText: "Firebase backend service" },
                ],
            },
            {
                title: "React Native + AWS Amplify",
                description: "Cloud-native services for storage, authentication, and deployment.",
                icons: [
                    { icon: "react.svg", altText: "AWS Amplify" },
                    { icon: "aws.svg", altText: "AWS cloud services" },
                ],
            },
            {
                title: "React Native + Supabase",
                description: "Open-source alternative for authentication, APIs, and database hosting.",
                icons: [
                    { icon: "react.svg", altText: "Supabase backend platform" },
                    { icon: "supabase.svg", altText: "Supabase backend platform" },
                ],
            },
            {
                title: "React Native + OpenAI (GPT-4 / GPT-4o)",
                description: "Conversational AI assistants, content generation, and smart search.",
                icons: [
                    { icon: "react.svg", altText: "OpenAI AI platform" },
                    { icon: "openai.svg", altText: "OpenAI AI platform" },
                ],
            },
            {
                title: "React Native + LangChain + Pinecone",
                description: "RAG-powered mobile AI assistants and contextual recommendations.",
                icons: [
                    { icon: "react.svg", altText: "Pinecone vector database" },
                    { icon: "langchain.png", altText: "LangChain framework" },
                ],
            },
            {
                title: "React Native + TensorFlow Lite / PyTorch Mobile",
                description: "On-device ML for personalization and offline inference.",
                icons: [
                    { icon: "tensorflow.svg", altText: "TensorFlow Lite" },
                    { icon: "pytorch.svg", altText: "PyTorch Mobile" },
                ],
            },
            {
                title: "React Native + Whisper + ElevenLabs",
                description: "Voice recognition, transcription, and natural speech experiences.",
                icons: [
                    { icon: "react.svg", altText: "ElevenLabs voice AI" },
                    { icon: "openai.svg", altText: "Whisper speech model" },
                ],
            },
            {
                title: "React Native + Hugging Face Transformers",
                description: "Sentiment analysis, summarization, and NLU integration.",
                icons: [
                    { icon: "react.svg", altText: "Hugging Face transformers" },
                    { icon: "huggin-face.png", altText: "Hugging Face transformers" },
                ],
            },
            {
                title: "React Native + Langfuse",
                description: "Real-time LLM analytics, observability, and performance tracing.",
                icons: [
                    { icon: "react.svg", altText: "Langfuse analytics platform" },
                    { icon: "langfuse.png", altText: "Langfuse analytics platform" },
                ],
            },
            {
                title: "React Native + Stripe / PayPal / Razorpay SDKs",
                description: "Secure, global multi-currency payments.",
                icons: [
                    { icon: "react.svg", altText: "Stripe payments" },
                    { icon: "paypal-icon.png", altText: "PayPal payments" },
                    { icon: "stripe.webp", altText: "Razorpay payments" },
                ],
            },
            {
                title: "React Native + Mixpanel / Amplitude / Firebase Analytics",
                description: "Deep product analytics and user engagement insights.",
                icons: [
                    { icon: "react.svg", altText: "Amplitude analytics" },
                    { icon: "mixpanel.png", altText: "Mixpanel analytics" },
                ],
            },
            {
                title: "React Native + Algolia / Elasticsearch",
                description: "Fast, intelligent in-app search and content discovery.",
                icons: [
                    { icon: "react.svg", altText: "Elasticsearch engine" },
                    { icon: "elasticsearch.svg", altText: "Algolia search engine" },
                ],
            },
            {
                title: "React Native + PostgreSQL / MongoDB Atlas",
                description: "Reliable, scalable database backends for mobile systems.",
                icons: [
                    { icon: "react.svg", altText: "PostgreSQL database" },
                    { icon: "mongodb.svg", altText: "MongoDB Atlas" },
                ],
            },
        ]
    },

    // How We Work Section
    howWeWork: {
        heading: "Why Leading Companies Trust Us with Their React Native Teams",
        subHeading: "From UI design to app deployment, our React Native workflow ensures transparency, efficiency, and measurable results. We deliver 99.9% crash-free builds, faster iteration cycles, and fully maintainable codebases.",
        features: [
            "Vetted Senior React Native Talent",
            "Timezone-Aligned Collaboration",
            "Proficient in Communication",
            "Full-Stack Mobile Expertise (React Native + Node.js/Firebase)",
            "Scalable Teams in Days",
            "Standard MSAs & SOWs",
            "NDA & IP Protection",
            "Enterprise-Grade Security",
            "Managed Delivery with Dedicated Leads"
        ]
    },

    // CoverTheStack Content
    coverTheStack: {
        whereStart: "Frontend & Mobile",
        shortHeading: "Tech Stack",
        mainHeading: "Comprehensive Expertise Across the React Native Ecosystem",
        subHeading: "Our developers leverage the latest tools and frameworks to ensure performance, maintainability, and scalability.",
        tabs: [
            "Frontend & Mobile",
            "Backend",
            "Database",
            "Cloud Services",
        ],
        tabItems: [
            { tab: "Frontend & Mobile", icon: "/images/tech-stack-icons/react.svg", name: "React Native" },
            { tab: "Frontend & Mobile", icon: "/images/tech-stack-icons/typescript.svg", name: "TypeScript" },
            { tab: "Frontend & Mobile", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
            { tab: "Backend", icon: "/images/tech-stack-icons/nodejs.svg", name: "Node.js" },
            { tab: "Backend", name: "Firebase", icon: "/images/tech-stack-icons/firebase.png" },
            { tab: "Backend", icon: "/images/tech-stack-icons/graphql.svg", name: "GraphQL" },
            { tab: "Database", icon: "/images/db1.png", name: "PostgreSQL" },
            { tab: "Database", icon: "/images/db7.png", name: "MongoDB" },
            { tab: "Database", icon: "/images/db3.png", name: "MySQL" },
            { tab: "Cloud Services", icon: "/images/cloud3.png", name: "AWS" },
            { tab: "Cloud Services", name: "Google Cloud", icon: "/images/cloud1.png" },
            { tab: "Cloud Services", icon: "/images/cloud2.png", name: "Azure" },
        ],
    },

    // Challenges & Solutions Section
    challengesSolutions: {
        shortHeading: "Challenges & Solutions",
        mainHeading: "Top Challenges in React Native App Development & Team Scalability",
        challenges: [
            {
                title: "Finding Skilled React Native Developers",
                description: "The demand for experienced React Native engineers far exceeds supply. Many developers are proficient in JavaScript or React.js but lack hands-on expertise in native module integration, performance optimization, and cross-platform architecture crucial for enterprise-level mobile solutions."
            },
            {
                title: "Slower Time-to-Market for Complex Apps",
                description: "React Native's flexibility comes with increased coordination between frontend, backend, and native teams. Without efficient pipelines and modular architecture, projects face longer build times, release delays, and reduced delivery velocity."
            },
            {
                title: "Native Performance Optimization Challenges",
                description: "Heavy reliance on JavaScript bridges or poorly managed component lifecycles often causes UI lag, animation stutter, and performance drops on lower-end devices. Balancing performance parity between iOS and Android remains a technical hurdle for many teams."
            }
        ],
        solutions: [
            {
                title: "Access to Pre-Vetted React Native Experts",
                description: "Get access to a pool of 400+ senior React Native developers experienced in native module integration, performance optimization, and cross-platform architecture. Each engineer passes multi-layered code reviews and live technical assessments."
            },
            {
                title: "Seamless 48-Hour Team Integration",
                description: "Our engineers integrate into your existing workflows within 48 hours. We align sprint cycles, version control, and communication tools like Slack, Jira, and GitHub, enabling instant collaboration and zero onboarding delays."
            },
            {
                title: "Automated CI/CD for Faster App Delivery",
                description: "We implement automated build, test, and deployment pipelines using tools like Fastlane, App Center, and GitHub Actions cutting manual work by up to 40% and reducing app release cycles by 35%."
            }
        ]
    },

    reactNativeBenefits: [
        {
            title: "Access to Pre-Vetted React Native Experts",
            description:
                "Get access to a pool of 400+ senior React Native developers experienced in native module integration, performance optimization, and cross-platform architecture. Each engineer passes multi-layered code reviews and live technical assessments, ensuring you work only with production-ready professionals."
        },
        {
            title: "Seamless 48-Hour Team Integration",
            description:
                "Our engineers integrate into your existing workflows within 48 hours. We align sprint cycles, version control, and communication tools like Slack, Jira, and GitHub, enabling instant collaboration and zero onboarding delays."
        },
        {
            title: "Automated CI/CD for Faster App Delivery",
            description:
                "We implement automated build, test, and deployment pipelines using tools like Fastlane, App Center, and GitHub Actions cutting manual work by up to 40% and reducing app release cycles by 35%, ensuring quicker time-to-market and consistent delivery."
        },
        {
            title: "Optimized Architecture & Cloud Scalability",
            description:
                "We architect modular React Native frameworks capable of scaling seamlessly across large codebases. Combined with AWS Amplify, Firebase, or Azure, our infrastructure design reduces cloud expenses by up to 30% while boosting performance and reliability."
        },
        {
            title: "Enterprise-Grade Security & Compliance",
            description:
                "Every project follows GDPR, ISO, and SOC 2 standards. We encrypt data, secure APIs, and manage user authentication through OAuth2 and SSL pinning, safeguarding your entire app ecosystem from codebase to cloud."
        },
        {
            title: "Continuous Monitoring & Performance Analytics",
            description:
                "Our DevOps and QA teams continuously monitor build stability and app performance, improving load times by 25% and maintaining 99.9% crash-free sessions. Regular audits ensure smooth scalability as your user base grows."
        }
    ],

    // HireExpertFacts Content
    expertFacts: {
        btnText: "book an appointment",
        heading: "Why Work with ",
        greenHeading: "Our React Native Engineers?",
        facts: [
            { text: "<strong>7+ Years of React Native Expertise:</strong> Deep experience in building scalable, high-performance cross-platform applications." },
            { text: "<strong>100+ Mobile Apps Delivered:</strong> Proven track record across eCommerce, fintech, healthcare, and enterprise solutions." },
            { text: "<strong>40% Faster Time-to-Market:</strong> Agile CI/CD workflows and optimized development processes accelerate delivery." },
            { text: "<strong>99.9% Crash-Free Build Rate:</strong> Enterprise-grade quality assurance and performance optimization across platforms." },
            { text: "<strong>Seamless Team Integration:</strong> Our engineers work as an extension of your team, following your workflows and tools." },
            { text: "<strong>Flexible Engagement Models:</strong> Scale your team up or down based on project needs without long-term commitments." },
        ],
        backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
    },

    // HirePageAppIdea Content
    appIdeaSection: {
        heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
        content: "Have an idea but unsure how to proceed? Our React Native experts can help you build a functional prototype in just 6-8 weeks! Validate your vision, test user engagement, & establish a strong foundation for success with our expert mobile app development services.",
    },

    // HirePageEngagementModels Component Props
    hirePageEngagementModels: {
        btnText: "Get Started Now",
        headingContent: [
            { text: "Flexible Engagement Models" },
            { text: "for Every Business" },
        ],
        discription: "Scale with Flexible Teams - Add pre-vetted React Native experts to your team to accelerate product delivery and reduce time-to-market. Dedicated Teams for Long-Term Success - Build a full-cycle React Native team for multiple products or large-scale app initiatives.",
        hiringDetails: [
            {
                text: "Hourly Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "time.svg",
                bgColor: "#FDFDFF",
                durationLabel: "Duration",
                duration: "Flexible Hours",
                minimumDaysLabel: "Minimum Commitment",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Start work in "
            },
            {
                text: "Full Time Hiring",
                hours: "72",
                timeUnit: "hours",
                icon: "full-time.svg",
                bgColor: "#FFFEFA",
                durationLabel: "Duration",
                duration: "8 Hrs/Day",
                minimumDaysLabel: "Minimum Commitment",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Get started within "
            },
            {
                text: "Part Time Hiring",
                hours: "48",
                timeUnit: "hours",
                icon: "part-time.svg",
                bgColor: "#FDFFFA",
                durationLabel: "Duration",
                duration: "4 Hrs/Day",
                minimumDaysLabel: "Minimum Commitment",
                minimumDays: "30 Days",
                billingLabel: "Billing",
                billing: "Monthly",
                startWorkPhrase: "Launch in "
            },
        ],
    },

    // SecondFaq Content
    faqSection: {
        mainHeading: "Frequently Asked Questions about React Native Development",
        faqData: [
            {
                id: "collapseOne",
                question: "How long does it take to get started with a React Native developer?",
                answer:
                    "Once we understand your project goals and technical requirements, Bitsclan IT Solutions can connect you with a qualified React Native engineer in 3–5 business days. Our onboarding process handles everything from repository setup to communication alignment ensuring a fast and seamless start.",
            },
            {
                id: "collapseTwo",
                question: "Can your React Native engineers work with my existing team?",
                answer:
                    "Absolutely. Our engineers integrate directly into your existing workflows, using your preferred tools like Slack, Jira, or Trello. They follow your sprint cycles, participate in daily standups, and operate as an extension of your internal team ensuring complete alignment and collaboration.",
            },
            {
                id: "collapseThree",
                question: "How do you ensure I’m getting the right talent for my project?",
                answer:
                    "Every React Native developer at Bitsclan IT Solutions passes a multi-stage vetting process, including real-world project simulations, performance tests, and communication assessments. You’ll only work with developers who have proven experience building and scaling React Native apps for production not entry-level coders.",
            },
            {
                id: "collapseFour",
                question: "What kind of apps can your React Native developers build?",
                answer:
                    "Our engineers specialize in cross-platform mobile apps that run seamlessly on both iOS and Android. This includes eCommerce platforms, on-demand service apps, fintech dashboards, social applications, and enterprise-grade tools, all designed for scalability and performance.",
            },
            {
                id: "collapseFive",
                question: "Can I scale my React Native development team as my project evolves?",
                answer:
                    "Yes. Our flexible engagement model lets you scale your team up or down as needed whether adding extra engineers for a release cycle or pausing between phases. There are no long-term commitments, just transparent scalability aligned with your business priorities.",
            },
            {
                id: "collapseSix",
                question: "Do you offer post-launch support and app maintenance?",
                answer:
                    "Yes. After your app goes live, we provide post-launch support that includes bug fixes, performance monitoring, security updates, and OS compatibility maintenance. Our goal is to ensure your app stays fast, secure, and reliable throughout its lifecycle.",
            },
            {
                id: "collapseSeven",
                question: "Will I have full ownership of the code and IP?",
                answer:
                    "Yes. All source code, design assets, and intellectual property created during your project remain 100% yours. We enforce strict NDAs, maintain secure access protocols, and guarantee complete IP protection under our standard agreements.",
            },
            {
                id: "collapseEight",
                question: "How do you maintain transparency and communication during projects?",
                answer:
                    "We use tools like Slack, Zoom, Jira, GitHub, and Trello to keep everything transparent. Regular milestone reviews, progress reports, and daily syncs ensure you’re always informed about timelines, deliverables, and technical updates.",
            },
            {
                id: "collapseNine",
                question: "Do your developers work in my time zone?",
                answer:
                    "Yes. Our React Native engineers work in time zone-aligned shifts, enabling real-time collaboration, faster feedback, and smooth communication with your internal teams regardless of where you’re located.",
            },
            {
                id: "collapseTen",
                question: "How much does it cost to work with a React Native developer?",
                answer:
                    "Costs depend on your project’s complexity, duration, and the experience level of the engineers. We offer hourly, part-time, and full-time options, ensuring flexibility and transparency so you only pay for the expertise you need, without hidden fees.",
            },
        ]
    },

    // Final CTA Section
    finalCta: {
        heading: "Ready to Build with World-Class React Native Engineers?",
        subHeading: "Empower your business with React Native engineers who build fast, scalable, and high-performance cross-platform apps.",
        btnText: "Let's Connect"
    },

    hireReactNativeEngagementModeContent: {
        shortHeading: "Engagement Models",
        heading: "Flexible Engagement Models for Every Business",
        // subheading: "Choosing the right engagement model is crucial. We offer flexible options, from dedicated development teams to project-based partnerships, ensure transparency, seamless collaboration, & maximum efficiency aligned with your AI, web, or IT project goals.",
        models: [
            {
                icon: "/images/engagement-model-gifs/hourly-icon.svg",
                index: 1,
                iconWidth: 40,
                title: "Scale with Flexible Teams",
                description: "Add pre-vetted React Native experts to your team to accelerate product delivery and reduce time-to-market.",
            },
            {
                icon: "/images/engagement-model-gifs/price-icon.svg",
                index: 2,
                iconWidth: 35,
                title: "Dedicated Teams for Long-Term Success",
                description: "Build a full-cycle React Native team for multiple products or large-scale app initiatives.",
            }
        ],
        cta: {
            text: "iOS & Android, Fast. Access Top React Native Talent.",
            button: "Hire React Native Developers",
            link: "/contact-us",
        },
    },

    comapnyCtaContent: {
        heading: "Ready to Build with World Class React Native Engineers?",
        subHeading: "Empower your business with React Native engineers for fast, scalable, high performance apps.",
        buttonText: "Let’s Connect",
    }
};